import { render, staticRenderFns } from "./ConnectedBanksSonInvestigationModal.vue?vue&type=template&id=23a0e820&scoped=true"
import script from "./ConnectedBanksSonInvestigationModal.vue?vue&type=script&lang=js"
export * from "./ConnectedBanksSonInvestigationModal.vue?vue&type=script&lang=js"
import style0 from "./ConnectedBanksSonInvestigationModal.vue?vue&type=style&index=0&id=23a0e820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a0e820",
  null
  
)

export default component.exports